module.exports = __webpack_public_path__ + "media/svg-new/ic-avaliacao-4ee6b517.svg";